import styled from "styled-components";

export const AddIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  border-radius: 50%;
  &:hover {
    background-color: rgba(26, 28, 25, 0.12) !important;
  }
`;

export const MoreIcon = styled.div`
  width: 40px;
  height: 40px;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all ease-in-out 0.2s;
  &:hover {
    background-color: rgba(26, 28, 25, 0.12) !important;
  }
`;

export const WorkspaceFunctions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
